import { connect } from 'react-redux'
import ServiceViewPane from '../../components/services/view/ServiceViewPane'
import { fetchService, actionCreators } from '../../state/actions/services/index'
import { IStoreState } from '../../types/index'

const mapStateToProps = (state: IStoreState, ownProps: any) => {
  return {
    orgId: state.organizations.currentOrgId,
    serviceId: ownProps.match.params.id,
    routeProps: ownProps
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onComponentMount: (serviceId: string) => {
      dispatch(actionCreators.serviceEditClearState())
      dispatch(fetchService(serviceId))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceViewPane)



// WEBPACK FOOTER //
// ./src/containers/services/ServiceViewPane.ts